<template>
    <div>
        <p>Vaš spletni profil je zaščiten z geslom za dostop. Geslo lahko poljubno spreminjate. Priporočamo, da to storite vsake 3 mesece.</p>
        <template v-if="!displayForm">
            <v-snackbar
                    v-model="was_password_changed"
                    color="success"
                    top
            >
                Geslo je bilo uspešno spremenjeno.
                <v-btn
                        text
                        @click="was_password_changed = false"
                >
                    Zapri
                </v-btn>
            </v-snackbar>
            <v-btn class="noBtnMargin" depressed @click="changePassword()">Spremeni geslo</v-btn>
        </template>
        <template v-if="displayForm">
            <v-alert
                    :value="invalid_error_message"
                    type="error"
            >
                {{ invalid_error_message }}
            </v-alert>
            <v-form ref="form" v-model="valid" @submit.prevent="">
                <password-field v-model="currentPassword" label="Trenutno geslo" v-on:keypress.enter="doChangePassword" required autofocus />
                <password-field v-model="password" :rules="newPasswordRules" label="Novo geslo" v-on:keypress.enter="doChangePassword" required />
                <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpisano novo geslo" v-on:keypress.enter="doChangePassword" required />
            </v-form>
            <v-btn depressed block color="primary_action" :loading="loading" @click="doChangePassword">NASTAVI GESLO</v-btn>
            <v-btn depressed block @click="cancelChangePassword()" v-if="!loading" >PREKLIČI</v-btn>
        </template>
    </div>
</template>

<script>
    import PasswordField from "../../PasswordField";
    import validations from "../../validations";
    import {userService} from "../../../services";


    export default {
        name: "ChangePassword",
        components: {PasswordField},
        data: () => {
            return {
                loading: false,
                valid: false,
                currentPassword: null,
                password: null,
                password_again: null,
                displayForm: false,
                invalid_error_message: null,
                was_password_changed: false,
                newPasswordRules: validations.newPasswordRules,
            }
        },
        methods: {
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            changePassword(){
                this.displayForm = true;
                this.was_password_changed = false;
            },
            cancelChangePassword(){
                this.displayForm = false;
                this.was_password_changed = false;
            },
            doChangePassword(){
                let isValid = this.$refs.form.validate();
                if (isValid){
                    this.loading = true;
                    userService.changePassword(this.currentPassword, this.password).then((data) => {
                        this.currentPassword = null;
                        this.password = null;
                        this.password_again = null;
                        this.was_password_changed = true;
                        this.displayForm = false;
                    }, (error) => {
                        console.log('dsd', error);
                        this.invalid_error_message = error.message;
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

    .noBtnMargin {
        margin-left: 0px;
    }

</style>